import React from 'react'
import * as media from '../media'
import styled from 'styled-components'
import Text from '../text'
import TranslateText from 'src/text/modal';

const Header = styled.div`
  margin: 40px auto;
  font-size: 24px;
  ${media.smallerThan(700)`text-align: center;`}
`

const Description = styled.div`
  display: flex;
  ${media.smallerThan(900)` flex-direction: column-reverse; align-items: center;`}
`

const page = () => (
  <div>
    <div style={{ width: '80%', margin: '0 auto', fontSize: '18px' }}>
      <Header>
        <div style={{ display: 'inline-block', fontWeight: 600 }}>
          <TranslateText id="policy__header"/>
        </div>
      </Header>
      <div style={{ color: '#231F20' }}>
        <TranslateText
          id="policy__text"
          controls={['ol', 'ul']}
          useHtml
        />
      </div>
    </div>
  </div>
)

export default page


// WEBPACK FOOTER //
// ./src/pages/policy.js